import React, { useState, useRef } from 'react';
import { Title, Text } from 'components/Texts';
import { Ghost } from 'components/Buttons';
import { colors } from 'globalStyle';
import {
  Box, Chip, Grid, styled,
} from '@material-ui/core';
import { MAPRO } from 'types/fileType';
import { isOverflown } from 'util/elementProperties';

export default function ProjectLongDescription({
  isDesktop, images, description, category,
}) {
  const textRef = useRef();
  const [showFullText, setShowFullText] = useState(isDesktop);

  return (
    <Grid container>
      <Box
        alt=""
        component="img"
        borderRadius="20px"
        src={images && (images[0]?.temporalResource || images[0])}
        height={isDesktop && '181px'}
        marginTop={!isDesktop && '20px'}
        marginBottom={!isDesktop && '20px'}
        width={isDesktop ? '281px' : '100%'}
        style={{
          objectFit: 'cover',
        }}
      />
      <Grid
        container
        direction="column"
        style={{
          rowGap: '20px',
          marginLeft: isDesktop && '40px',
          width: isDesktop && 'calc(100% - 321px)',
        }}
      >
        <Text size={isDesktop ? 16 : 13}>
          <TextContainer showFullText={showFullText} component="p" ref={textRef}>
            {description}
          </TextContainer>
          {!isDesktop && isOverflown(textRef?.current) && (
            <Ghost
              mt={10}
              isCenter
              isSubmit
              size={14}
              underline
              fullWidth
              color={colors.primary}
              onClick={() => setShowFullText((curr) => !curr)}
            >
              {showFullText ? 'Ver menos' : 'Ver más'}
            </Ghost>
          )}
        </Text>
        <Grid container alignItems="center" style={{ gap: '15px' }}>
          <Title size={14} mb={!isDesktop && 15} mr={isDesktop && 18} width={isDesktop && 'fit-content'}>
            Categoría:
          </Title>
          <Chip label={category} style={{ padding: isDesktop ? '10px 50px' : '10px 20px' }} />
          <Text color={colors.primary} style={{ textDecoration: 'underline', width: 'fit-content' }} size={14}>
            <a
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: 'inherit' }}
              href={MAPRO}
            >
              MAPRO
            </a>
          </Text>
        </Grid>
      </Grid>
    </Grid>
  );
}

const TextContainer = styled(Box)((props) => ({
  overflow: 'hidden',
  whiteSpace: 'pre-wrap',
  maxHeight: props.showFullText ? 'initial' : '130px',
}));
